import { action } from 'typesafe-actions';
import { FilterTypes, FilterState } from './types';

export const updateFilter = (nextFilter: FilterState) =>
  action(FilterTypes.UpdateFilter, nextFilter);
